
export const REDUCER_NAME="productSlice"

export interface iProductDetails {
    product: {
      currency: string;
    priceIncreasePercent: any;
      measurement: string;
      discount: number;
      taxRate: number;
    
      id?: string;
      vendor_id: string;
      title: string;
      sku: string;
      product_type: string;
      category_id: string;
      subCategory:string
      description: string;
      product_image: string | null;
      images:string[];
      videos:string[];
      price: string;
      cost_price: string;
      packagingCharges?:number;
      isPackagingCharges?:boolean;
      taxesAndCharges: string;
      sale_price: string;
      retail_price: string;
      rating?: number;
      isFeaturedProduct?:boolean;
      inventory_status: string;
      availability: string;
      global_trade_item_number: string;
      manufacturer_part_number: string;
      brand_name: string;
      product_upc_ean: string;
      is_shipping_free: number;
      page_title: string;
      meta_keywords: string;
      meta_description: string;
      product_url: string;
      delivery_event_name: string;
      delivery_from_date: string | null;
      delivery_to_date: string | null;
      created_at: string;
      updated_at: string;
      currentStock: string|number;
      lowStock: string|number;
      customFields?:Array<{label:string,value:string}>;
			shippingPrice?: number;
      internationalshippingPrice:number;
			tags?: Array<string>;
      sizes?: string[];
      color_images?: string[];
      about: string;
      unit: string;
      taxOptions: string;
      brand: string;
      imported_product_reference?:string|null;
      imported_from_vendor?:string|null;
      supplier_name?:string|null;
    };
    variants: iVariant[];
    shipping_details: iShippingDetail[];
    reviews?:any[]

  }
  
  interface iVariant {
    variant_name: string;
    variant_value: string;
  }
  
  interface iShippingDetail {
    location_name: string;
    shipping_charge: string;
  }

  export interface iProductState {
      isLoading: boolean;
      products: iProductDetails[]; // `OrderData` type will store the order structure
      selectedProduct?: iProductDetails; // Optional for single product
      errorMessage: string | null;
      bestSellingProducts:[],
       pagination: {
    currentPage: number;
    totalPages: number;
    limit: number;
    totalCount: number;
  } | null;
  
    }